import { Component, Inject } from "@angular/core";
import { StateService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialog } from "../../../shared/confirm-dialog.component";
import { PersonDataService } from "../../../core/persons.dataservice";
import { AuthServerProvider } from "../../../shared/auth/auth.service";
import * as fileHelper from "../../../shared/file.helper";
import * as dataCore from "../../../core/datacore";
import { CompetenceTypeDataService } from "../../../core/competencetypes.dataservice";
import { CompetenceGroupsService } from "../../../core/competencegroups.dataservice";

@Component({
    selector: "crew-person-competence",
    template: require('./person.competence.component.html'),
    styles: [require('../../../shared/nullable-date.css')]
})
export class PersonCompetenceComponent {

    public ValidFrom: Date;
    public ExpirationDate: Date;

    public get checkValidFrom(): boolean {
        return !this.ValidFrom;
    }

    public get checkExpiration(): boolean {
        return !this.ExpirationDate;
    }

    constructor(
        @Inject(PersonDataService.Id) private personDataService: PersonDataService,
        @Inject("person") person: Nema.Crew.Model.Person,
        @Inject("personCompetence") public personCompetence: Nema.Crew.Model.PersonCompetence,
        private stateService: StateService,
        private dialog: MatDialog,
        @Inject('$log') private $log: ng.ILogService,
        private authServerProvider: AuthServerProvider,
        @Inject(CompetenceTypeDataService.Id) competenceTypeDataService: CompetenceTypeDataService,
        @Inject(CompetenceGroupsService.Id) competenceGroupDataService: CompetenceGroupsService) {
        
        this.ValidFrom = dataCore.addTimezoneOffset(this.personCompetence.ValidFrom);
        this.ExpirationDate = dataCore.addTimezoneOffset(this.personCompetence.Expiration);

        this.personName = person.Name;

        competenceTypeDataService.get(this.personCompetence.CompetenceTypeId)
            .then(competenceType => {
                this.competenceTypeName = competenceType.Name;
                return competenceType;
            })
            .then(competenceType => competenceGroupDataService.get(competenceType.CompetenceGroupId))
            .then(competenceGroup => this.competenceGroupName = competenceGroup.Name);

        this.hasExistingFile = !!this.personCompetence.AttachmentFileContentId;
    }

    public hasExistingFile: boolean;

    public personName: string;

    public competenceGroupName: string;

    public competenceTypeName: string;

    public entityName = "Person Competence";

    public editStateName = "app.resources.persons.competences.edit";

    public listStateName = "app.resources.persons.detail";
    
    public edit(): void {
        this.stateService.go(this.editStateName, { personCompetenceId: this.personCompetence.Id });
    }

    public delete(): void {

        var self = this;

        this.dialog
            .open(ConfirmDialog)
            .afterClosed()
            .subscribe(res => self.onDeleteEntity(self, res));
    }

    private onDeleteEntity(self: PersonCompetenceComponent, shouldDelete?: boolean) {
        if (shouldDelete) {

            self.personDataService.removeMapping(this.personCompetence, () => { });

            // Delete the file
            self.personDataService
                .deleteFileContent(fileHelper.getPersonCompetenceFileDownloadUrl(this.personCompetence.Id))
                // Then the delete the competence
                .then(() => {
                    self.personDataService
                        .save(self.personCompetence.Person)
                        .then(() => {
                            self.backToList();
                        })
                        .catch(err => self.$log.error("Error deleting the entity.\n\nError is: " + err));
                });
        }
    }

    public backToList(): void {
        this.stateService.go(this.listStateName, { id: this.personCompetence.PersonId });
    }

    public downloadFile() {
        window.open(fileHelper.getPersonCompetenceFileDownloadUrl(this.personCompetence.Id, this.authServerProvider.getToken()));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/competences/person.competence.component.ts